import { Injectable } from '@angular/core';
import { MODULE_DEFINITIONS } from 'src/app/constants/module-definitions';

export interface ResolvedDefaultRoute {
  moduleSegment: string;
  submodulePath: string;
  fullPath: string;
  moduleType: number;
  submoduleId: number;
}

@Injectable({
  providedIn: 'root',
})
export class DefaultRouteNavigationService {
  private routeMap = new Map<number, ResolvedDefaultRoute>();
  private routeMapPromise: Promise<void> | null = null;

  async resolveNavigationPath(idSubmodulo: string | number | null | undefined): Promise<string | null> {
    if (idSubmodulo == null || idSubmodulo === '') {
      return null;
    }

    await this.ensureRouteMapBuilt();
    const resolved = this.routeMap.get(Number(idSubmodulo));
    return resolved?.fullPath ?? null;
  }

  async getResolvedRoute(idSubmodulo: string | number | null | undefined): Promise<ResolvedDefaultRoute | null> {
    if (idSubmodulo == null || idSubmodulo === '') {
      return null;
    }

    await this.ensureRouteMapBuilt();
    return this.routeMap.get(Number(idSubmodulo)) ?? null;
  }

  private ensureRouteMapBuilt(): Promise<void> {
    if (!this.routeMapPromise) {
      this.routeMapPromise = this.buildRouteMap();
    }
    return this.routeMapPromise;
  }

  private async buildRouteMap(): Promise<void> {
    const moduleEntries = Object.values(MODULE_DEFINITIONS);

    await Promise.all(
      moduleEntries.map(async (moduleDef) => {
        try {
          const routingModule = await import(
            `../../modules/${moduleDef.moduleFolder}/${moduleDef.moduleFolder}-routing.module`
          );
          const routes = routingModule.routes ?? [];

          routes.forEach((route: { path?: string; data?: { permission?: number } }) => {
            if (!route?.path || route.path === '**' || route.data?.permission == null) {
              return;
            }

            const submoduleId = Number(route.data.permission);
            if (Number.isNaN(submoduleId)) {
              return;
            }

            this.routeMap.set(submoduleId, {
              moduleSegment: moduleDef.routeSegment,
              submodulePath: route.path,
              fullPath: `${moduleDef.routeSegment}/${route.path}`,
              moduleType: moduleDef.type,
              submoduleId,
            });
          });
        } catch {
          /* Módulo no disponible en este build */
        }
      })
    );
  }
}
